import { useIntersectionObserver } from "@/components/organisms/mixins/intersection-observer.mixin";

export const productListOurSelectionProps = () => ({
  filterVisible: {
    type: Boolean,
    default: false
  },
  ourSelectionPush: {
    type: Object,
    default: null
  },
  productsListMode: {
    type: String,
    default: "Grid"
  },
  label: {
    type: String,
    required: false
  },
  ourSelection: {
    typ: Array,
    required: true
  }
});

export const productListOurSelectionEmits = () => ["onProductIntersect"];

export const useProductListOurSelection = (emit) => {
  const { onIntersect } = useIntersectionObserver({ emit });

  const formattedPrice = (price) => {
    const fixedAmount = price ? parseFloat(price).toFixed(2) : price;
    return fixedAmount;
  };
  const onProductIntersect = (i) => {
    emit("onProductIntersect", i);
  };

  return { onIntersect, formattedPrice, onProductIntersect };
};
